import React, { useEffect, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import {checkCookie, eraseCookie} from 'ubs-framework/v2/common/function';
import AppHeader from '../../app-account/common/components/app-header'
import * as Icon from 'ubs-icons'
import { COLOR } from '../../common/constant'
import { isInApp } from 'ubs-framework/v2/common/function'
import { sendData } from '../../store/actions'
import useSocket from '../../app-account/common/useSocket'
import { useDispatch, useSelector } from 'react-redux'
import {withRouter} from "../../common/hocs/routing-hoc";
import UAvatar from 'ubs-framework/v2/UAvatar'
import { getName } from 'ubs-framework/v2/common/function';
import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

function useQuery() {
    const query = new URLSearchParams(useLocation().search);
    const queryParams = {};
    query.forEach((value, key) => {
      queryParams[key] = value;
    });
    return queryParams;
}

function Layout({ children, module, projectRoutes, className, style, logoURL, isHidelogo }) {
    const { orgId } = useParams()
    const history = useHistory()
    const dispatch = useDispatch()
    const params = useQuery();
    const [toggleLoginBtn, setToggleLoginBtn] = useState(false)
    const [details, setDetails] = useState(null)
    const _IA = useSelector(e => e.common.authData);
    const _LID = useSelector(e => e?.common?.logInDetails)
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL)

    const isShowHeader = ['multiFactorAuthenticate', 'setupMultiFactor', 'workspace', 'companyDetails', 'companyOtherInfo'].includes(module);

    const { on, off, refresh } = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'getCompanyDetails':
                    setDetails(res.data)
                    break
                default:
                    return true
            }
        }
    })
    useEffect(() => {
        if (!checkCookie('ubs_token')) setToggleLoginBtn(true)
        else setToggleLoginBtn(false)
        if(orgId) sendData(dispatch, 'getCompanyDetails', { orgId })
        else setDetails(null)

        refresh()
        return () => off()
    }, [])

    const redirectToRegister = () => {
        const slugType = localStorage.getItem('slugType')
        if(slugType) history.push(`/${slugType}/register`)
        else history.push('/register')
    }

    const logout = () => {
        if (localStorage.getItem('notification_token')) sendData('logout', {device_token: localStorage.getItem('notification_token')})
        dispatch({type: 'LOGOUT'})
        localStorage.clear()
        eraseCookie('ubs_token')
        eraseCookie('signup_token')
        eraseCookie('ubsTabId')
        history.push('/login')
        window.location.reload(true)
    }

    return (
        <section className="u_acc u_h-full">

            {!isHidelogo && <div className='u_p-24 u_flex u_content-between'>
                <a href="https://superworks.com" target="_blank">
                    <img src="/images/images/superworks-logo.png" height={40} className="u_cp" />
                </a>
                {logoURL && (<div className="top-right-logo">
                    <img className="u_logo-top" height={65} width={65} src={logoURL} alt="Logo" />
                </div>)}
            </div>}

            {/*<UCustomScrollBar>*/}
            <div className={`u_acc-inner ${isHidelogo ? 'u_mt-30 u_my-15' : ''}`}>

                <div className="u_acc-inner__input u_align-center">
                    <div className="u_login-input__section">

                        <div className={`u_acc-form ${className}`} style={style}>
                            {isShowHeader && _IA && <div className="u_py-16 u_px-24 u_flex-align u_content-between u_bb-light">
                                <div className="u_flex-align">
                                    <UAvatar name={getName(_IA)} image={_IA?.profileImage} s3Url={_S3_BASE_URL} width={38} height={38} />
                                    <div className="u_pl-12">
                                        <p className="u_small-font u_one-line u_color-title u_text-bold u_mb-6">Hi, {getName(_IA) || '-'}</p>
                                        <span className="u_flex-align u_small-font u_color-title">
                                            <Icon.Mail size={16} fill={COLOR.u_icon_bg} className="u_mr-8" />
                                            {_IA?.email || _LID?.email}
                                        </span>
                                    </div>
                                </div>
                                <div className="u_flex-align">
                                    <Icon.PowerButton size={16} fill={COLOR.u_pastelred} className="u_mr-6" />
                                    <span className="u_small-font u_color-red u_cp u_text-bold" onClick={logout} data-testid={TEST_ID.WORKSPACE.LOGOUT_BUTTON}>Logout</span>
                                </div>
                            </div>}
                            {children}
                        </div>

                        {(module === 'register') && toggleLoginBtn &&
                        <p className="u_send-code u_t-center u_mt-20">Already have an account? <span className="u_cp" onClick={e => history.push('/login')}>Sign In</span></p>}

                        {(module === 'login') && toggleLoginBtn && !isInApp() &&
                        <p className="u_send-code u_t-center u_mt-20">Don’t have an account? <span className="u_cp" onClick={e => redirectToRegister()}>Sign Up</span></p>}

                        {(module === 'forgot') && toggleLoginBtn &&
                        <p className="u_send-code u_t-center u_mt-20">Remember Password ? <span className="u_cp" onClick={e => history.push('/login')}>Sign In</span></p>}

                        {(module === 'on-boarding-forgot') && toggleLoginBtn &&
                        <p className="u_send-code u_t-center u_mt-20">Remember Password ? <span className="u_cp" onClick={e => history.push(projectRoutes?.login || `/${orgId}/login`)}>Sign In</span></p>}

                        {(module === 'on-boarding-register') && toggleLoginBtn &&
                        <p className="u_send-code u_t-center u_mt-20">Already have an account? <span className="u_cp" onClick={e => history.push(projectRoutes?.login || `/${orgId}/login`)}>Sign In</span>
                        </p>}

                        {(module === 'on-boarding-login') && toggleLoginBtn && !isInApp() &&
                        <p className="u_send-code u_t-center u_mt-20">Don’t have an account? <span className="u_cp" onClick={e => history.push(projectRoutes?.register || `/${orgId}/register`)}>Sign Up</span>
                        </p>}

                        {(module === 'multiFactorAuthenticate') && toggleLoginBtn &&
                        <p className="u_send-code u_t-center u_mt-20">Don’t have an Google Authenticator code? <span className="u_cp" onClick={e => history.push(projectRoutes?.recoveryCode || `/${orgId}/recovery-code`)}>Add Recovery Code</span>
                        </p>}
                    </div>
                </div>
            </div>
            {!isHidelogo && <div className="u_copyright u_flex u_content-center u_align-center">
                <p className="u_t-center">Copyright © 2020-{new Date().getFullYear()} Superworks Company. All rights reserved.</p>
            </div>}
        </section>
    )
}


Layout.defaultProps = {
    module: 'both',
}

export default withRouter(Layout)
